"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPoints = formatPoints;
var _getFormattedNumber = require("../internals/getFormattedNumber");
var _makeSpacesNonBreakable = require("../internals/makeSpacesNonBreakable");
var _formatNumber = require("./formatNumber");
/**
 * Returns parameter `value` formatted as the points (Loyalty and other points).
 *
 * The `value` is formatted in the runtime culture in case:
 * - the {@link culture} setting is not provided,
 * - the number or points formatting rules are not available in the {@link culture} setting.
 * @see {@link formatNumber} for more information.
 *
 * @param value Numeric value to format
 * @param culture Culture settings containing formatting rules
 * @returns `value` formatted as the points
 * @example
  // basic usage
  import { formatPoints, useCulture } from '@ori/culture';
  const { culture } = useCulture();
  const formattedPoints = formatPoints(1234.567, culture);
 */
function formatPoints(value, culture) {
  const {
    numberFormat,
    pointsFormat
  } = culture ?? {};
  if (!numberFormat || !pointsFormat) {
    // it is preferred by the business to display the value formatted in the runtime culture than no value at all
    return (0, _formatNumber.formatNumber)(value, culture);
  }
  return (0, _makeSpacesNonBreakable.makeSpacesNonBreakable)((0, _getFormattedNumber.getFormattedNumber)(value, pointsFormat.decimals,
  // Points have only some different properties, otherwise it's just like a general number
  numberFormat.decimalSeparator, numberFormat.groupSizes, numberFormat.groupSeparator, {
    negativePattern: numberFormat.negativePattern,
    removeTrailingZeros: pointsFormat.removeTrailingZeros
  }));
}
//# sourceMappingURL=formatPoints.js.map